import React from 'react';
import styles from './landing-stats.module.scss';

export const LandingStats: React.FC = () => {
  const stats = [
    { number: '10 000+', label: 'записей создано' },
    { number: '500+', label: 'бизнесов используют' },
    { number: '99%', label: 'клиентов рекомендуют' },
  ];

  return (
    <div className={styles.landing_stats}>
      <div className={styles.landing_stats__inner}>
        {stats.map((stat, i) => (
          <div key={i} className={styles.stat_item}>
            <span className={styles.stat_item__number}>{stat.number}</span>
            <span className={styles.stat_item__label}>{stat.label}</span>
          </div>
        ))}
      </div>
    </div>
  );
};
